export const CONDITION_TYPES = {
    TERM: 1,
    BOOLEAN: 2,
    NUMBER: 3,
    NUMBER_RANGE: 4,
};

export const CONDITION_OPERATORS = {
    EQUAL: 1,
    NOT_EQUAL: 2,
    GREATER: 3,
    LESS: 4,
    BETWEEN: 5,
    MIN_BETWEEN: 6,
    MAX_BETWEEN: 7,
    IS_EMPTY: 8,
    STARTS_WITH: 9,
    ENDS_WITH: 10,
    CONTAINS: 11,
};

export const CONDITION_RELATION_TYPES = {
    OR: 1,
    AND: 2,
};
